import React from "react";

const Feature = () => {
  return (
    <>
      <br />

      <div id="feature" style={{ transform: "translateY(-70px)" }}></div>
      <section
        className="feature-section"
        style={{
          background: `url('/img/feature-bg.png') no-repeat center center / cover`,
        }}
      >
        <div className="container">
          <h5 className="section-title">FEATURES</h5>
          <div className="feature-wrapper">
            <img
              src={process.env.PUBLIC_URL + "/img/feature-shape.png"}
              className="feature-main-shape"
              alt=""
              data-aos="fade-in"
            />
            <div className="feature-area">
              {data?.map((item, index) => {
                return (
                  <div className="feature-item" key={index}>
                    <div data-aos="zoom-in">
                      <div className="img d-lg-none">
                        <img src={item.img} alt="" />
                      </div>
                      <div className="content">
                        <h6>{item.title}</h6>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const data = [
  {
    img: process.env.PUBLIC_URL + "/img/feature/1.png",
    title: "Performance",
    description:
      "Carbon offers a carefully written framework with performance as the number one factor to provide an even better experience for your players.",
  },
  {
    img: process.env.PUBLIC_URL + "/img/feature/2.png",
    title: "Oxide Support",
    description:
      "We have made it very easy to make the switch from Oxide to Carbon by keeping the folder/plugin structure the same.",
  },
  {
    img: process.env.PUBLIC_URL + "/img/feature/3.png",
    title: "Scalability",
    description:
      "We have made Carbon super lightweight by only providing the very essential hooks needed.",
  },
  {
    img: process.env.PUBLIC_URL + "/img/feature/4.png",
    title: "Hot Reload",
    description:
      "Carbon allows for your Harmony mods to be reloaded on the fly when changes are made.",
  },
  {
    img: process.env.PUBLIC_URL + "/img/feature/5.png",
    title: "Permissions",
    description:
      "We have created a more optimized modular permission system that allows for users to create thier own serializers.",
  },
  {
    img: process.env.PUBLIC_URL + "/img/feature/6.png",
    title: "Dynamic Hooks",
    description:
      "Hooks are loaded dynamically to ensure only the hooks used by plugins are loaded. This eliminates a ton of redundant calls and will improve the performance of your server.",
  },
];

export default Feature;
